export default "__VITE_ASSET__CUvrgn3z__"